"use client";

import React, { createContext, useContext, useState, ReactNode } from "react";
import Notification from "./Notification";

interface NotificationState {
  type: "success" | "error";
  message: string;
}

interface NotificationContextType {
  notify: (n: NotificationState) => void;
}

const NotificationContext = createContext<NotificationContextType | undefined>(undefined);

export function NotificationProvider({ children }: { children: ReactNode }) {
  const [notification, setNotification] = useState<NotificationState | null>(null);

  const notify = (n: NotificationState) => setNotification(n);

  return (
    <NotificationContext.Provider value={{ notify }}>
      {children}
      {notification && (
        <Notification
          type={notification.type}
          message={notification.message}
          onClose={() => setNotification(null)}
        />
      )}
    </NotificationContext.Provider>
  );
}

export function useNotification() {
  const ctx = useContext(NotificationContext);
  if (!ctx) throw new Error("useNotification must be used within a NotificationProvider");
  return ctx;
} 